import { createContext } from "react"
import type { MutableRefObject } from "react"
import type { AcceptAttachments } from "./use-accept-attachments"

export interface DockDropValue {
  acceptAttachmentsRef: MutableRefObject<AcceptAttachments | null>
}

export const DockDropContext = createContext<DockDropValue | null>(null)
